import type { CategoryId } from '@timelog/pm-shared';

/** Category accent colors from the design's bento cards. */
export const CATEGORY_COLORS: Record<CategoryId, string> = {
  own: 'var(--color-pink-80)',
  cont: 'var(--color-fog-80)',
  exp: 'var(--color-blue-80)',
  sub: 'var(--color-purple-60)',
  mat: 'var(--color-black-60)',
};
